<template lang="html">
  <div>{{ item.display_name }}</div>
  <!-- <div class="p-ml-3">{{item.display_name}}</div>
  <div class="p-ml-6">{{item.display_name}}</div> -->
</template>

<script>
export default {
  props: {
    item: { required: true },
  },
};
</script>
